module.exports = __webpack_public_path__ + "img/cover-thumbnail.c63e4cb2.jpg";